export class PreviewModeDialogResult {
  constructor(public ref: number, public refType: string) {}
}
